import React from 'react'

type TProps = {
  location: string
  isPopularTreatmentTypesCarousel: boolean
}

function CardLocation({ location, isPopularTreatmentTypesCarousel }: TProps) {
  return (
    <div
      className={`truncate text-sm ${
        isPopularTreatmentTypesCarousel ? 'text-gray-700' : 'text-gray-800'
      }`}
    >
      {location}
    </div>
  )
}

export default CardLocation
